﻿export interface LiveDataSet {
    Stations: { [stationId: string]: LiveDataSetStation };
}

export interface LiveDataSetStation
{
    Station: Station;
    GroupValues: { [groupId: string]: LiveDataSetValue[] };
}

export enum Status {
    Good,
    Expiring,
    Expired
}

export interface LiveDataSetValue
{
    //Timestamp: number;
    //Value: any;
    //Sensor: string;
    //Parameter: string;
    //ExpiryStatus: Status;
    //Primary: boolean;
    StationId: string;
    ParameterGroup: string;
    Sensor: string;
    Primary: boolean;
    Parameter: string;
    Timestamp: number;
    Value: any;
    ExpiryStatus: Status;
}